import {NgModule} from '@angular/core';
import {MaterialModule} from '../material/material.module';
import {ContractComponent} from './components/contract/contract.component';
import {ContractAdHocServicesComponent} from './components/contract-ad-hoc-services/contract-ad-hoc-services.component';
import {ContractAfterEntryGroupsComponent} from './components/contract-after-entry-groups/contract-after-entry-groups.component';
import {ContractFieldAddDialogComponent} from './components/contract-field-add-dialog/contract-field-add-dialog.component';
import {ContractFieldGroupsComponent} from './components/contract-field-groups/contract-field-groups.component';
import {ContractServicesComponent} from './components/contract-services/contract-services.component';
import {ContractsComponent} from './components/contracts/contracts.component';
import {FlightScheduleComponent} from './components/flight-schedule/flight-schedule.component';
import {
  FlightScheduleColumnEditorComponent
} from './components/flight-schedule-column-editor-dialog/flight-schedule-column-editor-dialog.component';
import {FlightScheduleEditorComponent} from './components/flight-schedule-editor/flight-schedule-editor-dialog.component';
import {FlightScheduleTableComponent} from './components/flight-schedule-table/flight-schedule-table.component';
import {InvoiceItemComponent} from './components/invoice-item/invoice-item.component';
import {ResourceDataTableComponent} from './components/resource-data-table/resource-data-table.component';
import {ContractService} from './services/contract/contract.service';
import {ContractFieldGroupService} from './services/contract-field-group/contract-field-group.service';
import {ContractItemService} from './services/contract-item/contract-item-service.service';
import {FlightScheduleColumnsService} from './services/flight-schedule-columns/flight-schedule-columns.service';
import {FlightScheduleService} from './services/flight-schedule-service/flight-schedule.service';
import {PossibleScheduleColumnsService} from './services/possible-schedule-columns/possible-schedule-columns.service';
import {UtilitiesModule} from '../utilities/utilities.module';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {FieldsModule} from '../fields/fields.module';

@NgModule({
  declarations: [
    ContractComponent,
    // field groups
    ContractFieldGroupsComponent,
    ContractServicesComponent,
    ContractAdHocServicesComponent,
    ContractAfterEntryGroupsComponent,
    ContractFieldAddDialogComponent,
    ContractsComponent,
    FlightScheduleComponent,
    FlightScheduleColumnEditorComponent,
    FlightScheduleEditorComponent,
    FlightScheduleTableComponent,
    InvoiceItemComponent,
    ResourceDataTableComponent,
  ],
  entryComponents: [
    ContractFieldAddDialogComponent,
    FlightScheduleColumnEditorComponent,
    FlightScheduleEditorComponent
  ],
  imports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    UtilitiesModule,
    ReactiveFormsModule,
    RouterModule,
    FieldsModule
  ],
  exports: [
    // components
    ContractComponent,
    ContractFieldGroupsComponent,
    ContractServicesComponent,
    ContractAdHocServicesComponent,
    ContractAfterEntryGroupsComponent,
    ContractFieldAddDialogComponent,
    ContractsComponent,
    FlightScheduleComponent,
    FlightScheduleColumnEditorComponent,
    FlightScheduleEditorComponent,
    FlightScheduleTableComponent,
    InvoiceItemComponent,
    ResourceDataTableComponent,
  ],
  providers: [
    ContractService,
    ContractFieldGroupService,
    ContractItemService,
    FlightScheduleColumnsService,
    FlightScheduleService,
    PossibleScheduleColumnsService
  ]
})
export class ContractModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/contract/contract.module.ts